module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.$store.state.showCart) ? _c('div', {
    ref: "cartWrapper",
    staticClass: "cart-wrapper"
  }, [_c('div', {
    staticClass: "cart"
  }, [_c('OnClickOutside', {
    attrs: {
      "do": function () { return _vm.$store.commit('toggleCart'); }
    }
  }, [_c('div', {
    staticClass: "overflow-y-auto max-h-screen"
  }, [_c('cart-product-list', {
    attrs: {
      "supplyOrders": _vm.supplyOrders,
      "removeProduct": _vm.removeProduct,
      "deleteSupplyOrder": _vm.deleteSupplyOrder
    }
  })], 1)])], 1)]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-63ab97ba","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/cart/Cart.vue
// module id = 636
// module chunks = 66